import React from "react";

import { tabFeatureAttributeBlock } from "../elementIDs";
import {
    ITabFeatureAttributeBlock_AttributeTab,
    ITabFeatureAttributeBlock_ModelTab,
} from "../models.interfaces";

import styles from "./TabFeatureAttributeBlockModelTabButton.module.scss";

type TabFeatureAttributeBlockModelTabButtonProps = {
    attrIdx: number;
    attrTab: ITabFeatureAttributeBlock_AttributeTab;
    modelIdx: number;
    modelTab: ITabFeatureAttributeBlock_ModelTab;
    onClick: () => void;
    isSelected: boolean;
};

export const TabFeatureAttributeBlockModelTabButton = ({
    attrIdx,
    attrTab,
    modelIdx,
    modelTab,
    onClick,
    isSelected,
}: TabFeatureAttributeBlockModelTabButtonProps): React.JSX.Element => {
    return (
        <button
            className={styles.root}
            id={tabFeatureAttributeBlock.modelTabButton(
                attrTab,
                attrIdx,
                modelTab,
                modelIdx,
            )}
            type="button"
            role="tab"
            aria-controls={tabFeatureAttributeBlock.modelTabContent(
                attrTab,
                attrIdx,
                modelTab,
                modelIdx,
            )}
            tabIndex={isSelected ? 0 : -1}
            aria-selected={isSelected}
            onClick={onClick}
            dangerouslySetInnerHTML={{
                __html: modelTab.model_name,
            }}
        ></button>
    );
};
